import * as React from 'react';

function DetailsSvgIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} viewBox="0 0 24 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14 9a18.679 18.679 0 002.464 3.316C6.397 14.226 8.9 16 12 16c3.1 0 5.605-1.774 7.395-3.684A18.682 18.682 0 0021.86 9a18.679 18.679 0 00-2.464-3.316C17.605 3.774 15.101 2 12 2 8.9 2 6.396 3.774 4.605 5.684A18.676 18.676 0 002.14 9zM23 9l.894-.448-.002-.003-.003-.007-.011-.022a9.224 9.224 0 00-.192-.354 20.676 20.676 0 00-2.831-3.85C18.895 2.226 15.899 0 12 0 8.1 0 5.104 2.226 3.145 4.316a20.675 20.675 0 00-2.831 3.85 12.357 12.357 0 00-.192.354l-.011.022-.003.007-.002.002s0 .002.894.449l-.894-.447a1 1 0 000 .894L1 9l-.894.447.002.004.003.007.011.022.04.078c.036.065.086.159.152.276a20.67 20.67 0 002.831 3.85C5.105 15.774 8.1 18 12 18c3.9 0 6.895-2.226 8.855-4.316a20.672 20.672 0 002.831-3.85 11.794 11.794 0 00.192-.354l.011-.022.003-.007.002-.002s0-.002-.894-.449zm0 0l.894.447c.141-.281.14-.613 0-.895L23 9z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7a2 2 0 100 4 2 2 0 000-4zM8 9a4 4 0 118 0 4 4 0 01-8 0z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDetailsSvgIcon = React.memo(DetailsSvgIcon);
export default MemoDetailsSvgIcon;
